import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import State from 'src/models/State';
// import actions from 'src/actions';
// import { useDispatch } from 'react-redux';
import useFetch from 'use-http';
import { BsSearch } from 'react-icons/bs';
import { FaRegSave } from 'react-icons/fa';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import arrayMutators from 'final-form-arrays';
import County from 'src/models/County';
import TagContainer from 'src/components/counties/TagContainer';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import { ODataOptions, ODataFilter, ODataFilterOperators, /*ODataOrderByDirection*/ } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { SelectItem } from 'src/models/common/SelectItem';
import { Form } from 'react-final-form';
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import TsdiSubcode from 'src/models/AP/Subcode';
import AltSubCode from 'src/models/AP/AltSubcode';

interface IAltSubCodeDialogProps {
    dialogName: string;
    subCode: TsdiSubcode;
    project: ProspectDetails;
    client: TsdiClientInfo;
    handleReport?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    showAddSubcodeDialog?: () => void;
    setAddingAltSubcode?: (addingAltSubcode: boolean) => void;
    setFindingAltSubcode?: (findingAltSubcode: boolean) => void;
    setShowBillingSettings?: (showBillingSettings: boolean) => void;
}

const AltSubCodeDialog = (props: IAltSubCodeDialogProps) => {
    const { register, reset, getValues } = useForm();
    // const dispatch = useDispatch();
    const { register: registerState, /*reset: resetState*/ } = useForm();
    const { register: registerClientProspect, /*reset: resetState*/ } = useForm();
    const { get, /*post,*/ put, response } = useFetch();
    const [selectStates, setSelectStates] =  useState<Array<{ value: string; label: string }>>(undefined);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [selectedState, setSelectedState] = useState<number>(undefined);
    const [selectStateCounties, setSelectStateCounties] = useState<Array<SelectItem>>(undefined);
    const [selectedUnit, setSelectedUnit] = useState<ProspectDetails>(undefined);
    const [countiesForUpdate, setCountiesForUpdate] = useState<Array<County>>(null);
    const [saveCountiesRef, setSaveCountiesRef] = useState<HTMLButtonElement>(null);
    const [stateCounties, setStateCounties] = useState<PagedResultSet<County>>(undefined);
    const [altSubcodeSearchOptions, setAltSubcodeSearchOptions] = useState<ODataOptions>(undefined);
    const [altSubcodeSearchTerm, setAltSubcodeSearchTerm] = useState<string>('');
    const [altSubcodes, setAltSubcodes] = useState<Array<TsdiSubcode>>(undefined);
    const [addingNewUnit, setAddingNewUnit] = useState<boolean>(false);

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!altSubcodes) {
            populateAltSubcodeForm(altSubcodes[0]);
        }
    }, [altSubcodes]);

    useEffect(() => {
        if (!!selectedState) {
            console.log(selectedState);
        }
    }, [selectedState]);

    useEffect(() => {
        if (!!countiesForUpdate) {
            updateUnit(generateUpdatePayload());
        }
    }, [countiesForUpdate]);

    useEffect(() => {
        if (!!addingNewUnit) {
            props?.showAddSubcodeDialog();
        }
    }, [addingNewUnit]);

    useEffect(() => {
        if (states?.items?.length) {

            let list = states?.items?.map(s => {
                return {
                    label: (!!s.name ? `(${s.name})` : ''),
                    value: `${s.id}` };
            });
            setSelectStates(list);
        }
    }, [states]);

    useEffect(() => {
        if (!!altSubcodeSearchOptions) {
            getAltSubCodes();
        }
    }, [altSubcodeSearchOptions]);

    useEffect(() => {
        if ((!!altSubcodeSearchTerm || altSubcodeSearchTerm === '') && !!altSubcodeSearchOptions) {
            resetAltSubcodeSearchOptions();
        }
    }, [altSubcodeSearchTerm]);

    useEffect(() => {
        if (!!stateCounties && stateCounties?.items?.length > 0) {
            setSelectStateCounties(stateCounties ? stateCounties?.items?.map((c: County) => new SelectItem(c.id, c.name)) : undefined);
        }
    }, [stateCounties]);

    const onCreate = () => {
        getStates();
        const saveCountiesButtonRef = document.getElementById('saveCountiesButton') as HTMLButtonElement;
        if (!!saveCountiesButtonRef) {
            setSaveCountiesRef(saveCountiesButtonRef);
        }
        getAltSubCodes();
    };

    const resetAltSubcodeSearchOptions = () => {
        let newProjectSearchOptions = _.cloneDeep(altSubcodeSearchOptions);
        newProjectSearchOptions.setIsNextpage(true);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 1000);
        const projectId = !!props?.project?.id ? props?.project?.id : 0;
        if (!projectId) {
            return;
        }
        newProjectSearchOptions.addFilter(new ODataFilter('s.[PR_ID]', ODataFilterOperators.Equals, projectId));
        if (typeof altSubcodeSearchTerm === 'string') {
            const fieldValues = altSubcodeSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0])) && fieldValues[0] !== ' ' && fieldValues[0]?.length > 0) {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NO]', ODataFilterOperators.Equals, !!altSubcodeSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined && fieldValues[1]?.length > 0 && fieldValues[1] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('u.[UN_NAME]', ODataFilterOperators.Contains, !!altSubcodeSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && fieldValues[2]?.length > 0 && fieldValues[2] !== ' ') {
                newProjectSearchOptions.addFilter(new ODataFilter('s.[SECTION_TYPE]', ODataFilterOperators.Contains, !!altSubcodeSearchTerm ? fieldValues[2] : ''));
            }
        }
        setAltSubcodeSearchOptions(newProjectSearchOptions);
    };

    const onAltSubcodeSearchChanged = (searchContent: string) => {
        search();
    };

    const search = _.debounce(() => {
        const formData = getValues();
        const projectId = !!props?.project?.id ? props?.project?.id : 0;
        if (!projectId) {
            return;
        }
        let searchString =  (!!formData?.searchSubcodeNumber ? formData.searchSubcodeNumber : ' ');
        searchString += ',' +  (!!formData?.searchSubcodeName ? formData.searchSubcodeName : ' ');
        searchString += ',' +  (!!formData?.searchSubcodeType ? formData.searchSubcodeType : ' ');
        setAltSubcodeSearchTerm(searchString);
    }, 700);

    const onSubmit = () => {
        console.log('OK Clicked');
        let data = getValues();

        props.handleReport(getValues('category'), getValues('subcategory'));
        props.hideDialog();

        console.log(data);
    };

    const getStates = async () => {
        const result = await get(`/v1.0/states`);

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to retrieve States data.');
        }
    };

    const getUnit = async (clientNumber: number, projectNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectNumber}/client/${clientNumber}`);

        if (response.ok) {
            setSelectedUnit(result);
        }
    };

    const updateUnit = async (payload: ProspectDetails) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/project`, payload);

        if (response.ok && result === 1) {
            getUnit(props?.client?.clientNumber, props?.project?.number);
        }
    };

    const displayTitle = () => {
        const title = 'Alt Subcode Maintenance';

        return title;
    };

    const displaySubTitle = () => {
        const title = 'Alt Subcode Settings';

        return title;
    };

    const generateUpdatePayload = () => {
        alert('Implement Update Alt Sub Code');
        return new ProspectDetails();
    };

    const onSubmitCounties = (formData: { addCounties: Array<County> }) => {
        setCountiesForUpdate(formData.addCounties);
    };

    const onSaveChanges = () => {
        saveCountiesRef.click();
    };

    const onStateSelected = (id: number) => {
        setSelectedState(id);
        getStatesCounties(id);
    };

    const getStatesCounties = async (id: number) => {
        const result = await get(`/v1.0/States/${id}/counties`);

        if (!!result && response.ok) {
            setStateCounties(result);
        } else {
            console.log('Unable to retrieve the Counties for selected State.');
        }
    };

    const getAltSubCodes = async () => {
        const queryString = altSubcodeSearchOptions?.toString();
        const subCodeId = props?.subCode?.id;
        if (subCodeId > 0) {
            let result = await get(`/v1.0/ClientProjectMaintenance/subcode/${subCodeId}/altsubcodes${queryString !== undefined ? queryString : ''}`);

            if (response.ok) {
                setAltSubcodes(result);
            } else {
                setAltSubcodes([]);
                console.log('Unable to get subcode data!');
            }
        }
    };

/*     const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    }; */

    const findUnit = (addNewProject: boolean) => {
        if (!!addNewProject) {
            setAddingNewUnit(true);
        } else {
            setAddingNewUnit(false);
            props?.setFindingAltSubcode(true);
        }
    };

    const moveToNextAltSubCode = () => {
        alert('Implement move to next alt sub code');
    };

    const moveToPreviousAltSubCode = () => {
        alert('Implement move to previous alt sub code');
    };

    const moveToFirstAltSubCode = () => {
        alert('Implement move to first alt sub code');
    };

    const moveToLastAltSubCode = () => {
        alert('Implement move to last alt sub code');
    };

    const onCancel = () => {
        props.hideDialog();        
    };

    const OKClicked = () => {
        props.hideDialog();
    };

    const populateAltSubcodeForm = (payload: AltSubCode) => {
        reset(payload);
    };

    const displaySubcodeSettingButtons = () => {
        return (
            <>
                <RHFInputBox
                    onChange={(event) => onAltSubcodeSearchChanged(event.currentTarget.value)}
                    name={'clientNumber'}
                    defaultVal={props?.client?.clientNumber?.toString()}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '60%' }}
                    register={registerClientProspect}
                    readOnly={true}
                />
                <RHFInputBox
                    name={'projectNumber'}
                    defaultVal={props?.project?.number?.toString()}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '60%' }}
                    register={registerClientProspect}
                    readOnly={true}
                />
                <RHFInputBox
                    name={'subcodeNumber'}
                    defaultVal={props?.subCode?.number?.toString()}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '60%' }}
                    register={registerClientProspect}
                    readOnly={true}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Find Alt Subcode"
                    reactIcon={BsSearch}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => props.setFindingAltSubcode(true)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Alt Subcode"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToFirstAltSubCode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Subcode"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToPreviousAltSubCode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Add New Alt Subcode"
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={() => props.setAddingAltSubcode(true)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Save Alt Subcode Changes"
                    reactIcon={FaRegSave}
                    type={'button'}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => onSaveChanges()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Project"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToNextAltSubCode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Project"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToLastAltSubCode()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Billing"
                    reactIcon={FaFileInvoiceDollar}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => props?.setShowBillingSettings(true)}
                />
            </>
        );
    };

    const displaySubcodeSettings = () => {
        return (
            <>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Alt Subcode'}
                    labelOnLeft={true}
                    name={'number'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={'altSubcode (POI) Name'}
                    labelOnLeft={true}
                    name={'name'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={'AFE #'}
                    labelOnLeft={true}
                    name={'afeNumber'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Client Account Code'}
                    labelOnLeft={true}
                    name={'clientAccountCode'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={'Cost Center Code'}
                    labelOnLeft={true}
                    name={'costCenter'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={'Gross Acres'}
                    labelOnLeft={true}
                    name={'grossAcres'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Client Landman'}
                    labelOnLeft={true}
                    name={'clmNumber'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={''}
                    labelOnLeft={true}
                    name={'clientLandmanName'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                    <Button
                        className="blue-hover-button"
                        type="button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Invoice Groups'}
                        onClick={() => alert('Implement Invoice Group')}
                    />
                    <Button
                        className="blue-hover-button"
                        type="button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Create Invoice Groups'}
                        onClick={() => alert('Implement Create Invoice Group')}
                    />
                </div>
            </>
        );
    };

    const displayCounties = () => {
        return (
            <>
                <table>
                    <thead>
                        <th>
                            State
                        </th>
                        <th>
                            County
                        </th>
                    </thead>
                    <tbody>
                    {selectedUnit?.counties?.map((c, index) =>
                        <tr key={index}>
                            <td>
                                {c?.state}
                            </td>
                            <td>
                                {c?.county}
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </>);
    };

    return (
        <>
        <Dialog title="Alt Subcode Maintenance" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '60vw' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form id={`AltSubcodeMaintenanceForm`} onSubmit={onSubmit}>
                <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <RHFInputBox
                                                name={'clientNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientProspect}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'projectNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientProspect}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'projectNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientProspect}
                                                readOnly={true}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Alt Subcode"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findUnit(false)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Alt Subcode"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToFirstAltSubCode()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Subcode"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToPreviousAltSubCode()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Alt Subcode"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => props.setAddingAltSubcode(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Save Alt Subcode Changes"
                                                reactIcon={FaRegSave}
                                                type={'button'}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => onSaveChanges()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Project"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToNextAltSubCode()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Project"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToLastAltSubCode()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Billing"
                                                reactIcon={FaFileInvoiceDollar}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => props?.setShowBillingSettings(true)}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displaySubTitle()}>
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                        {displaySubcodeSettingButtons()}
                                    </div>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                        {displaySubcodeSettings()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={'Counties'}>
                                    <div style={{display: 'flex', width: '100%', justifyContent: 'left'}}>
                                    <Form
                                        onSubmit={onSubmitCounties}
                                        mutators={{ ...arrayMutators }}
                                        render={({ handleSubmit, form }) => {
                                            return (
                                                <form onSubmit={handleSubmit}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                        <div style={{ display: 'flex', gap: '2rem', width: '98%' }}>
                                                            {selectStates && <RHFSelect
                                                                label="State"
                                                                name="stateId"
                                                                options={selectStates}
                                                                defaultVal={'Select State'}
                                                                onChange={(e) => onStateSelected(Number(e.currentTarget.value))}
                                                                style={{ width: '100%' }}
                                                                register={registerState}
                                                                bodyStyle={{ width: '30%' }}
                                                            />}
                                                            <TagContainer
                                                                label="Subcode Counties"
                                                                isTagCreatable={false}
                                                                fieldArrayName="counties"
                                                                fieldAddArrayName="addCounties"
                                                                fieldDeleteArrayName="deleteCounties"
                                                                initialValueName="county"
                                                                form={form}
                                                                selectTags={selectStateCounties ? selectStateCounties : new Array<SelectItem>()}
                                                            />
                                                            <div style={{display: 'flex', justifyContent: 'center', width: '20vw' }}>
                                                                {displayCounties()}
                                                            </div>
                                                            <Button
                                                                style={{display: 'none'}}
                                                                id={'saveCountiesButton'}
                                                                type={'submit'}
                                                                text={'Save Counties'}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            );
                                        }}
                                    />
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <div style={{whiteSpace: 'nowrap', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'OK'}
                            onClick={() => OKClicked()}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => onCancel()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
        </>
    );
};

export default AltSubCodeDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/AlternateSubCodeDialog.tsx